import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { BreadcrumbModule } from 'primeng/breadcrumb'

import { SeverityMarkerComponent } from '@flowx/designer/modules/misconfigurations/components/severity-marker/severity-marker.component'
import {
  BreadcrumbsComponent,
  FlxBreadcrumbItem,
} from '@flowx/designer/shared/components/breadcrumbs/breadcrumbs.component'

/** The subheader: breadcrumbs, which are also the way back, and the page's own actions. */
@Component({
  selector: 'flx-resource-header',
  imports: [BreadcrumbModule, BreadcrumbsComponent, NgClass, SeverityMarkerComponent],
  templateUrl: './resource-header.component.html',
  styleUrls: ['./resource-header.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  host: { '[class.dark]': 'darkMode()', '[class.light]': '!darkMode()' },
})
export class FlxResourceHeaderComponent {
  breadcrumbs = input<FlxBreadcrumbItem[]>([])
  darkMode = input<boolean>(true)

  /**
   * Misconfiguration errors for the open resource. `null` — the default — renders no badge, which
   * is also what a cold start and a hidden-markers preference resolve to.
   */
  errorCount = input<number | null>(null)

  errorBadgeCount = computed((): number => this.errorCount() ?? 0)
}
